module.exports = __webpack_public_path__ + "img/icon-k.7e3d93dd.svg";